
import { getProductList } from '@/assets/js/api/'

const getDefaultState = () => {
	return {
		list: [],
		total: 0
	}
}

const state = getDefaultState()

const mutations = {
	RESET_STATE: (state) => {
		Object.assign(state, getDefaultState())
	},
	SET_PORDUCT_LIST:(state, list) => {
		state.list = list;
	},
	SET_PORDUCT_TOTAL:(state, total) => {
		state.total = total;
	},
}

const actions = {
	// user login
	// get user info
	getPorduct({ commit, state }, shop_id) {
		return new Promise((resolve, reject) => {
			getProductList({shop_id: shop_id}).then(response => {
				const { data } = response;
				commit('SET_PORDUCT_LIST', data.list);
				commit('SET_PORDUCT_TOTAL', data.total);
				resolve(data)
			}).catch(error => {
				reject(error)
			})
		})
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}


// WEBPACK FOOTER //
// ./src/store/product.js